import React from 'react';

/**
 * Universal KPI Stat Card Component for Dashboards
 */
export default function StatCard({
  title,
  value,
  subtitle = null,
  icon = null,
  color = 'sky', // 'sky' | 'emerald' | 'violet' | 'amber' | 'rose'
  trend = null, // e.g. { value: '+12%', isPositive: true }
  onClick,
  className = '',
}) {
  const colorMap = {
    sky: 'bg-sky-50 text-sky-600 border-sky-100',
    emerald: 'bg-emerald-50 text-emerald-600 border-emerald-100',
    violet: 'bg-violet-50 text-violet-600 border-violet-100',
    amber: 'bg-amber-50 text-amber-600 border-amber-100',
    rose: 'bg-rose-50 text-rose-600 border-rose-100',
  };

  const iconBgMap = {
    sky: 'bg-sky-500/10 text-sky-600',
    emerald: 'bg-emerald-500/10 text-emerald-600',
    violet: 'bg-violet-500/10 text-violet-600',
    amber: 'bg-amber-500/10 text-amber-600',
    rose: 'bg-rose-500/10 text-rose-600',
  };

  return (
    <div
      onClick={onClick}
      className={`
        bg-white rounded-2xl p-5 border border-slate-200/80 shadow-sm
        transition-all duration-200 hover:shadow-md hover:border-slate-300
        flex items-center justify-between gap-4
        ${onClick ? 'cursor-pointer active:scale-[0.99]' : ''}
        ${className}
      `}
    >
      <div className="flex flex-col min-w-0">
        <span className="text-xs font-semibold uppercase tracking-wider text-slate-400 truncate">
          {title}
        </span>
        <span className="text-2xl font-bold text-slate-800 mt-1 tracking-tight truncate">
          {value ?? 0}
        </span>
        {subtitle && (
          <span className="text-xs text-slate-500 mt-0.5 truncate">{subtitle}</span>
        )}
        {trend && (
          <div className="flex items-center gap-1 mt-1.5 text-xs font-semibold">
            <span className={trend.isPositive ? 'text-emerald-600' : 'text-rose-500'}>
              {trend.value}
            </span>
            <span className="text-slate-400 font-normal">vs last month</span>
          </div>
        )}
      </div>

      {icon && (
        <div
          className={`w-12 h-12 rounded-2xl flex items-center justify-center text-xl flex-shrink-0 ${
            iconBgMap[color] || iconBgMap.sky
          }`}
        >
          {icon}
        </div>
      )}
    </div>
  );
}
